import { Grid } from "@mui/material";
import { GridItem } from "Components/Shared/GridItem";
import { FormSection } from "Components/Shared/FormSection";
import { Resources, useResource } from "Translations/Resources";

const FORM_RESOURCES =
  Resources.Pages.Content.UserDetailPageContent.Tabs.User.Form;

type Props = {
  verificationDailyBuyLimit: number;
  verificationMonthlyBuyLimit: number;
};

export const LimitsSection = ({
  verificationDailyBuyLimit,
  verificationMonthlyBuyLimit,
}: Props) => {
  const { t } = useResource();

  return (
    <FormSection legend={t(FORM_RESOURCES.Legend.Limits)} noMargins>
      <Grid container spacing={2}>
        <GridItem
          columns={2}
          label={t(FORM_RESOURCES.VerificationDailyBuyLimit)}
          value={verificationDailyBuyLimit}
        />
        <GridItem
          columns={2}
          label={t(FORM_RESOURCES.VerificationMonthlyBuyLimit)}
          value={verificationMonthlyBuyLimit}
        />
      </Grid>
    </FormSection>
  );
};
